import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import DataTable from "../../shared/component/dataTable/DataTable";
import PurchaseOrderColumn from "../../shared/component/dataTable/columns/PurchaseOrderColumn.json";
import PurchaseOrderMobileColumn from "../../shared/component/dataTable/columns/PurchaseOrderMobileColumn.json";
import {Button} from "reactstrap";
import Translate from "../../shared/language/Translate";
import {toast} from "react-toastify";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import LicenseService from "../../shared/service/LicenseService";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import AvField from "../../shared/component/form/AvField";
import {PURCHASE_ORDER_STATUS} from "../../shared/utils/Constants";
import '../../shared/styles/SettingsPage.css';


export default class PurchaseOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasInvoiceLicense: false,
            purchaseOrderStatus: "INVOICE",
            id: ""
        }
        this.licenseService = new LicenseService();
        this.purchaseOrderService = new PurchaseOrderService();
    }

    componentDidMount() {
        this.licenseService.getLicenses(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                if (response.hasInvoiceLicense == true && response.remainingCredit != null && response.remainingCredit > 0) {
                    this.setState({
                        hasInvoiceLicense: true
                    }, () => {
                        this.refreshDataTable();
                    });

                } else {
                    return toast.warn("You don't have an invoice license or your credit has run out.");
                }
            } else {
                return toast.warn("You don't have an invoice license or your credit has run out.");

            }
        });

        // 10 saniyede bir refresh (mevcut filtre/sorting korunur)
        this.refreshInterval = setInterval(() => {
            this.refreshDataTableSilent();
        }, 1000 * 10); // 10000ms = 10s
    }

    componentWillUnmount() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }



    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.purchaseOrderList()}
                    </div>
                </AvForm>
            </div>
        );
    }

    purchaseOrderList() {
        return (
            <>
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Invoice List</h1>
                </div>
                <div className="settings-page__panel">
                    <div className="settings-page__invoice-toolbar">
                    <div className="settings-page__invoice-toolbar-status">
                        <AvGroup className="mb-0">
                            <AvField
                                type="select"
                                className="form-control"
                                name="purchaseOrderStatus"
                                disabled={false}
                                value={this.state.purchaseOrderStatus}
                                onChange={this.__handleChange}
                            >
                                {PURCHASE_ORDER_STATUS.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>
                                ))}
                            </AvField>
                        </AvGroup>
                    </div>
                    <div className="settings-page__invoice-toolbar-telegram">
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--action settings-page__btn--wrap"
                            onClick={() => {
                                if (this.state.hasInvoiceLicense) {
                                    this.purchaseOrderService.telegramRegister().then((response) => {
                                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                            window.open(response.url, '_blank');
                                        }
                                    });
                                } else {
                                    return toast.warn("You don't have an invoice license or your credit has run out.");
                                }
                            }}
                        >
                            <Translate contentKey="entity.action.add">Connect Telegram</Translate>
                        </Button>
                    </div>
                    </div>

                    <div className="settings-page__toolbar settings-page__toolbar--start settings-page__toolbar--equal-height">
                        <Button color="outline-primary" className="settings-page__btn--add settings-page__btn--manual-entry"
                                onClick={() => {
                            this.addNew("MANUAL_ENTRY");
                        }}>
                            <Translate contentKey="entity.action.add">Manual Entry</Translate>
                        </Button>

                        <Button color="outline-primary" className="settings-page__btn--add"
                                style={{minWidth: '12.5rem'}}
                                onClick={() => {
                                    this.addNew("UPLOAD");
                                }}>
                            <Translate contentKey="entity.action.add">Smart Invoice Processor</Translate>
                        </Button>

                        <Button color="outline-primary" className="settings-page__btn--add"
                                          onClick={() => {
                                              this.addNew("CSV");
                                          }}>
                            <Translate contentKey="entity.action.add">Import CSV</Translate>
                        </Button>
                    </div>

                    {this.state.hasInvoiceLicense &&
                        <div className="settings-page__table-wrap">
                            <DataTable
                                ref={(elem) => (this.refDataTable = elem)}
                                fields={(GeneralUtils.isMobile() ? PurchaseOrderMobileColumn.fields : PurchaseOrderColumn.fields)
                                    .filter(field => {
                                        if (field.maxWidthVisible && window.innerWidth < field.maxWidthVisible) {
                                            return false;
                                        }
                                        return true;
                                    })}
                                objectName={GeneralUtils.isMobile() ? PurchaseOrderMobileColumn.fields : PurchaseOrderColumn.fields}
                                dataURL={this.state.hasInvoiceLicense ? "inventory/purchaseOrder/all" : null}
                                rows={20}
                                autoLoad={false}
                                selectionMode="single"
                                onDataSelect={this.onDataSelect}
                                loading={this.state.loading}
                            />
                        </div>
                    }
                </div>
            </>)
    }


    refreshDataTable = () => {
        if (!this.state.hasInvoiceLicense || !this.refDataTable) return;

        const { purchaseOrderStatus } = this.state;
        let value = purchaseOrderStatus;
        let type = "string";
        let filterMatchMode = "equals";

        if (purchaseOrderStatus === "INVOICE") {
            value = ["INVOICE", "PARTIAL_CLOSED"];
            type = "list";
            filterMatchMode = "in";
        }

        if (this.refDataTable.dt) {
            this.refDataTable.dt.filter(value, "purchaseOrderStatus", filterMatchMode);
        }

        this.refDataTable.onModelFilterChangeWithNameAndValue(
            "purchaseOrderStatus",
            value,
            type,
            null,
            filterMatchMode
        );
    };

    refreshDataTableSilent = () => {
        if (!this.state.hasInvoiceLicense || !this.refDataTable) return;

        const { purchaseOrderStatus } = this.state;
        let value = purchaseOrderStatus;
        let type = "string";
        let filterMatchMode = "equals";

        if (purchaseOrderStatus === "INVOICE") {
            value = ["INVOICE", "PARTIAL_CLOSED"];
            type = "list";
            filterMatchMode = "in";
        }

        this.refDataTable.reloadWithCurrentState({
            purchaseOrderStatus: { value, type, filterMatchMode }
        });
    };


    onDataSelect = (data) => {
        if (this.state.hasInvoiceLicense) {
            window.location.href = "#purchaseOrderSave?" + data.id + "?" + data.invoiceType;
        } else {
            return toast.warn("You don't have an invoice license or your credit has run out.");

        }

    }

    addNew(invoiceType) {
        if (this.state.hasInvoiceLicense) {
            window.location.href = "#purchaseOrderSave?" + "-1" + "?" + invoiceType;
        } else {
            return toast.warn("You don't have an invoice license or your credit has run out.");

        }


    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;

        this.setState({
            purchaseOrderStatus: value
        }, () => {
            this.refreshDataTable()
        });
    }


}
